import { render, staticRenderFns } from "./modal-production-add-workers-all.vue?vue&type=template&id=1ce9b71a&scoped=true&"
import script from "./modal-production-add-workers-all.vue?vue&type=script&lang=js&"
export * from "./modal-production-add-workers-all.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-add-workers-all.vue?vue&type=style&index=0&id=1ce9b71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce9b71a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ce9b71a')) {
      api.createRecord('1ce9b71a', component.options)
    } else {
      api.reload('1ce9b71a', component.options)
    }
    module.hot.accept("./modal-production-add-workers-all.vue?vue&type=template&id=1ce9b71a&scoped=true&", function () {
      api.rerender('1ce9b71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-add-workers-all.vue"
export default component.exports